import React, {useState, useEffect, useRef} from 'react';
import {useForm, FormProvider} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers';
import SelectInfinite from '../../../components/FormFields/SelectInfinite';
import InputText from '../../../components/FormFields/InputText';
import TextArea from '../../../components/FormFields/Textarea';
import * as yup from 'yup';
import {getLanguage, t} from 'react-switch-lang';
import {Col, Row} from 'react-bootstrap';
import PageHeader from '../components/PageHeader';
import {useHistory} from 'react-router-dom';
import {
  getAllSubProcesses,
  addLitigation,
  getAllSubCategories,
  getAllSubCauses,
  GetPotentionalRisk, getDepartmentsLoginUser, getSubjectStatus,
} from '../../../services/litigationService';
import SelectList from '../../../components/select/SelectList';
import './AddLitigation.scss';
import {useUserContext} from '../../../contexts/UserContext';
import Toast from '../../../components/toast/Toast';
import InputDate from '../../../components/FormFields/inputDate/InputDate';
import {useDepartmentContext} from '../../../contexts/DepartmentContext';
import {defaultMinValueZero} from '../../../utils/const';
import PreventTransitionPrompt from '../../../components/preventTransitionprompt/PreventTransition';
import {format} from 'date-fns';
import {
  parseFormattedNumber,
  maxDecimalNumber,
  onDecimalNumberInputChange, testIsGreaterThanMin,
  testValidNumber, handlePasteAndValidate, formatNumber, formatNumberInput, formatNumberForDisplay,
} from '../../../utils/helpers';
import FileUploadSection from '../../../components/FileUploadSection/FileUploadSection'
import {getAllRiskTypes} from "../../../services/reports/reports";
import {getDepartment} from '../../../services/IncurredEvent/incurredEventApi';
import Swal from 'sweetalert2';
import LossModal from '../../IncurredRisk/components/modals/LossModal';
import editImage from '../../IncurredRisk/components/img/edit.svg';
import deleteImage from '../../IncurredRisk/components/img/delete.svg';

const AddLitigation = () => {
  const lang = getLanguage();
  const user = useUserContext();
  const userDepartment = useDepartmentContext();
  const [deletedLossIds, setDeletedLossIds] = useState([]);

  // const [disableSubprocess, setDisableSubPorcess] = useState(true);
  // const [disableSubCauses, setDisableSubCauses] = useState(true);
  // const [subProcesses, setSubProcesses] = useState([]);
  // const [subCauses, setSubCauses] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [disableSubCategory, setDisableSubCategory] = useState(true);
  const [riskEstimation, setRiskEstimation] = useState(null);
  const [departmentOptions, setDepartmentOptions] = useState([]);
  const [isAdding, setIsAdding] = useState(true);
  const [userResponsibleLogin,setUserResponsibleLogin] = useState();
  // const [subprocessPage, setSubprocessPage] = useState(0);
  // const [hasMoreSubprocesses, setHasMoreSubprocesses] = useState(true);
  // const [loadingSubprocesses, setLoadingSubprocesses] = useState(false);
  // const [subCausePage, setSubCausePage] = useState(0);
  // const [hasMoreSubCauses, setHasMoreSubCauses] = useState(true);
  // const [loadingSubCauses, setLoadingSubCauses] = useState(false);
  const [subCategoriesPage, setSubCategoriesPage] = useState(0);
  const [hasMoreSubCategories, setHasMoreSubCategories] = useState(true);
  const [loadingSubCategories, setLoadingSubCategories] = useState(false);
  const [lossModalOpen,setLossModalOpen] = useState(false);
  const [lossData, setLossData] = useState([]);
  const [isEdit,setIsEdit] = useState(false);
  const [currentID,setCurrentID] = useState();
  const [subjectStatusOptions, setSubjectStatusOptions] = useState([]);
  const [subCategoriesSearch, setSubcategoriesSearch] = useState('');

  let history = useHistory();

  const bankLegitimation = [
    {value: 'RESPONDENT', label: lang === 'eng' ? 'Respondent' : 'Tuženi'},
    {value: 'PLAINTIFF', label: lang === 'eng' ? 'Plaintiff' : 'Tužilac'},
  ];

  const [schema, setSchema] = useState(
    yup.object().shape({
      title: yup
        .string()
        .trim()
        .required(t('message.fieldRequired'))
        .max(150, t('message.max', {max: 150})),
      description: yup
        .string()
        .trim()
        .required(t('message.fieldRequired'))
        .max(2048, t('message.max', {max: 2048})),
      // riskCauseId: yup.object().nullable().required(t('message.fieldRequired')),
      departmentStakeholderId: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      courtCategoryId: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      subCategory: yup.object().nullable().required(t('message.fieldRequired')),
      // userResponsibleId: yup.object().nullable().required(t('message.fieldRequired')),
      estimatedGrossLost: yup
        .string()
        .trim()
        .required(t('message.fieldRequired'))
          .test('is-greater-than-min', t('message.minValue', {min: defaultMinValueZero}), (value) => {
            return testIsGreaterThanMin(value,defaultMinValueZero);
          })
          .test('is-valid-number', t('message.mustBeNumber'), (value) => {
            return testValidNumber(value);
          }).test('max-two-decimals', t('message.maxTwoDecimals'), (value) => {
            return maxDecimalNumber(value);
          })
        // .matches(validDouble, t('message.onlyDecimalNumbers'))
        .max(20, t('message.max', {max: 20})),
      // methodologyId: yup
      //   .object()
      //   .nullable()
      //   .required(t('message.fieldRequired')),
      comment: yup
        .string()
        .trim()
        .max(2048, t('message.max', {max: 2048})),
      typeCourtDispute: yup
        .string()
        .trim()
        .required(t('message.fieldRequired'))
        .max(255, t('message.max', {max: 255})),
      bankLegitimation: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      proxyInfo: yup
        .string()
        .trim()
        .required(t('message.fieldRequired'))
        .max(255, t('message.max', {max: 255})),
      litigationDate: yup
        .string()
        .nullable()
        .required(t('message.fieldRequired')),
      disputeSubject: yup
        .string()
        .trim()
        .required(t('message.fieldRequired'))
        .max(255, t('message.max', {max: 255})),
      jurisdiction: yup
        .string()
        .trim()
        .required(t('message.fieldRequired'))
        .max(255, t('message.max', {max: 255})),
      litigationValue: yup
        .string()
        .trim()
        .required(t('message.fieldRequired'))
          .test('is-greater-than-min', t('message.minValue', {min: defaultMinValueZero}), (value) => {
            return testIsGreaterThanMin(value,defaultMinValueZero);
          })
          .test('is-valid-number', t('message.mustBeNumber'), (value) => {
            return testValidNumber(value);
          }).test('max-two-decimals', t('message.maxTwoDecimals'), (value) => {
            return maxDecimalNumber(value);
          })
        .max(20, t('message.max', {max: 20})),
      provisionAmount: yup
        .string()
        .trim()
        .nullable()
        // .required(t('message.fieldRequired'))
        //   .test('is-greater-than-min', t('message.minValue', {min: defaultMinValueZero}), (value) => {
        //     return testIsGreaterThanMin(value,defaultMinValueZero);
        //   })
        //   .test('is-valid-number', t('message.mustBeNumber'), (value) => {
        //     return testValidNumber(value);
        //   })
        .test('max-two-decimals', t('message.maxTwoDecimals'), (value) => {
            return maxDecimalNumber(value);
          })
        .max(20, t('message.max', {max: 20})),
      reimbursementProvision: yup
        .string()
        .trim()
        .required(t('message.fieldRequired'))
          .test('is-greater-than-min', t('message.minValue', {min: defaultMinValueZero}), (value) => {
            return testIsGreaterThanMin(value,defaultMinValueZero);
          })
          .test('is-valid-number', t('message.mustBeNumber'), (value) => {
            return testValidNumber(value);
          }).test('max-two-decimals', t('message.maxTwoDecimals'), (value) => {
            return maxDecimalNumber(value);
          })
        .max(20, t('message.max', {max: 20})),
      litigationLoss: yup
        .string()
        .trim()
        // .required(t('message.fieldRequired'))
        //   .test('is-greater-than-min', t('message.minValue', {min: defaultMinValueZero}), (value) => {
        //     return testIsGreaterThanMin(value,defaultMinValueZero);
        //   })
        //   .test('is-valid-number', t('message.mustBeNumber'), (value) => {
        //     return testValidNumber(value);
        //   })
      .test('max-two-decimals', t('message.maxTwoDecimals'), (value) => {
            return maxDecimalNumber(value);
          })
        .max(20, t('message.max', {max: 20})),
      subjectStatus: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      // process: yup.string().nullable().required(t('message.fieldRequired')),
      // subprocessId: yup
      //   .string()
      //   .nullable()
      //   .required(t('message.fieldRequired')),
      // riskSubCause: yup
      //   .string()
      //   .nullable()
      //   .required(t('message.fieldRequired')),
      lossChargedInsurance: yup
        .string()
        .when('netLoss', {
          is: (val) => !!val,
          then: yup
            .string()
            .required(t('message.fieldRequired'))
            .test('is-greater-than-min', t('message.minValue', { min: defaultMinValueZero }), (value) =>
              testIsGreaterThanMin(value, defaultMinValueZero)
            )
            .test('is-valid-number', t('message.mustBeNumber'), (value) =>
              testValidNumber(value)
            )
            .test('max-two-decimals', t('message.maxTwoDecimals'), (value) =>
              maxDecimalNumber(value)
            ),
          otherwise: yup.string().nullable(),
        }),
      lossChargedOther: yup
        .string()
        .when('netLoss', {
          is: (val) => !!val,
          then: yup
            .string()
            .required(t('message.fieldRequired'))
            .test('is-greater-than-min', t('message.minValue', { min: defaultMinValueZero }), (value) =>
              testIsGreaterThanMin(value, defaultMinValueZero)
            )
            .test('is-valid-number', t('message.mustBeNumber'), (value) =>
              testValidNumber(value)
            )
            .test('max-two-decimals', t('message.maxTwoDecimals'), (value) =>
              maxDecimalNumber(value)
            ),
          otherwise: yup.string().nullable(),
        }),
    courtDisputeOutcomeAssessment: yup
    .string()
    .trim()
    .required(t('message.fieldRequired'))
    .max(2000, t('message.max', {max: 2000}))
})
  );

  const methods = useForm({
    resolver: yupResolver(schema),
  });

  const {handleSubmit, watch, setValue,trigger} = methods;
  // const watchProcess = watch('process');
  const watchCategory = watch('courtCategoryId');
  const watchSubcategory = watch('subCategory');
  // const watchRiskCause = watch('riskCauseId');
  // const watchRiskSubcause = watch('riskSubCause');
  // const watchSubprocess = watch('subprocessId');
  const watchPotentialRisk = watch('riskType');
  const watchDepartmentSourceId = watch('departmentStakeholderId');
  const watchNetLoss = watch('netLoss');
  // const prevProcessRef = useRef();
  // const prevRiskCause = useRef();
  const prevRiskCategory = useRef();
  // const fetchSubprocesses = async (pageToLoad = 0, replace = false) => {
  //   if (!watchProcess?.value) return;
  //   try {
  //     setLoadingSubprocesses(true);
  //     const {data} = await getAllSubProcesses(
  //       watchProcess?.value,
  //       pageToLoad,
  //       20
  //     );
  //
  //     const mapped = data?.map((item) =>
  //       lang === 'eng'
  //         ? {value: item?.id, label: item?.nameEn}
  //         : {value: item?.id, label: item?.name}
  //     );
  //
  //     setSubProcesses(prev =>
  //       replace ? mapped : [...prev, ...mapped]
  //     );
  //
  //     setSubprocessPage(pageToLoad);
  //     setHasMoreSubprocesses(data.length === 20);
  //   }
  //   catch (e){
  //   }finally {
  //     setLoadingSubprocesses(false);
  //   }
  // };

 //  const fetchSubcauses = async (pageToLoad = 0, replace = false) => {
 //    if (!watchRiskCause?.value) return;
 //
 //    try {
 //      setLoadingSubCauses(true);
 //      const {data} = await getAllSubCauses(
 //        watchRiskCause.value,
 //        pageToLoad,
 //        20
 //      );
 //
 //      const mapped = data?.map((item) =>
 //        lang === 'eng'
 //          ? {value: item?.id, label: item?.nameEn}
 //          : {value: item?.id, label: item?.name}
 //      );
 //
 //      setSubCauses(prev =>
 //        replace ? mapped : [...prev, ...mapped]
 //      );
 //
 //      setSubCausePage(pageToLoad);
 //      setHasMoreSubCauses(data.length === 20);
 //    } catch (e) {
 //    }finally {
 //      setLoadingSubCauses(false);
 //    }
 //  };
 const fetchSubCategories = async (pageToLoad = 0, replace = false, search = '') => {
    if (!watchCategory?.value) return;

    try {
      setLoadingSubCategories(true);
      const {data} = await getAllSubCategories(
        watchCategory.value,
        pageToLoad,
        20,
        search
      );

      const mapped = data?.map((item) =>
        lang === 'eng'
          ? {value: item?.id, label: item?.nameEn}
          : {value: item?.id, label: item?.name}
      );

      setSubCategories(prev =>
        replace ? mapped : [...prev, ...mapped]
      );

      setSubCategoriesPage(pageToLoad);
      setHasMoreSubCategories(data.length === 20);
    } catch (e) {
    }finally {
      setLoadingSubCategories(false);
    }
  };
  useEffect(() => {
    const fetchDepartments = async () => {
      try {
        const { data } = await getDepartmentsLoginUser();
        const departmentsArray = data?.map((item) => ({
          value: item?.id,
          label: lang === 'eng' ? item?.nameEn : item?.name,
        }));

        setDepartmentOptions(departmentsArray);
      } catch (err){
        Swal.fire({
          text: `${t("message.errorApi")}`,
          icon: "error",
          confirmButtonText: "OK"
        });
      }
    };

    fetchDepartments();

  }, [lang]);

  // useEffect(() => {
  //   if (watchRiskCause?.value) {
  //     setDisableSubCauses(false);
  //
  //     const causeChanged =
  //       prevRiskCause.current !== undefined &&
  //       prevRiskCause.current !== watchRiskCause.value;
  //     if (causeChanged) {
  //       setValue('riskSubCause', '', {
  //         shouldValidate: false,
  //         shouldDirty: false,
  //       });
  //       setSubCauses([]);
  //       setSubCausePage(0);
  //       setHasMoreSubCauses(true);
  //     }
  //     prevRiskCause.current = watchRiskCause.value;
  //
  //     fetchSubcauses(0, true);
  //   } else {
  //     setDisableSubCauses(true);
  //     setSubCauses([]);
  //     setSubCausePage(0);
  //     setHasMoreSubCauses(true);
  //     prevRiskCause.current = undefined;
  //
  //     setValue('riskSubCause', '', {
  //       shouldValidate: false,
  //       shouldDirty: false,
  //     });
  //   }
  // }, [watchRiskCause]);

  useEffect(() => {
    if (watchPotentialRisk?.value) {
      const fetchPotentialRiskData = async () => {
        try {
          const {data} = await GetPotentionalRisk(watchPotentialRisk?.value);
          setRiskEstimation(data[0].riskEstimationId);
        } catch (e) {
          // console.log(e);
        }
      };
      fetchPotentialRiskData();
    }
  }, [watchPotentialRisk]);

  const handleCancel = (e) => {
    e.preventDefault();
    // TO-DO redirect to litigations
    window.location = '/dashboard';
  };

  const submitForm = async (data) => {
    const files = document.getElementById('upload').files;
    const date =
      format(new Date(data.litigationDate), 'yyyy-MM-dd') +
      'T' +
      format(new Date(data.litigationDate), 'hh:mm:ss');
    const riskTypes = await getAllRiskTypes();
    // 3 because riskTypeId is 3 in payload
    const isDelayedVerification = riskTypes?.data.find((riskType) => riskType.id === 3).delayedVerification;
    const payload = {
      courtSubcategoryRiskId: data.subCategory.value,
      typeCourtDispute: data.typeCourtDispute,
      bankLegitimation: data.bankLegitimation.value,
      commissioner: data.proxyInfo,
      // startingDateDispute: new Date(data.litigationDate),
      startingDateDispute: date,
      subjectDispute: data.disputeSubject,
      jurisdiction: data.jurisdiction,
      valueCourtDispute: parseFormattedNumber(data.litigationValue),
      provisionAmount: parseFormattedNumber(data.provisionAmount),
      feeReservation: parseFormattedNumber(data.reimbursementProvision),
      lossDispute: parseFormattedNumber(data.litigationLoss),
      subjectStatus: data.subjectStatus ? data.subjectStatus.value : null,
      delayedVerification: isDelayedVerification,
      netLoss: parseFormattedNumber(data?.netLossNumber),
      grossLoss: parseFormattedNumber(data?.grossLoss),
      lossChargedInsurance: parseFormattedNumber(data?.lossChargedInsurance),
      lossChargedOther: parseFormattedNumber(data?.lossChargedOther),
      courtDisputeOutcomeAssessment: data?.courtDisputeOutcomeAssessment,
      risk: {
        active: true,
        riskCategoryId: 3,
        userInChargeId: user.id,
        potentialRiskId: data.riskType ? data.riskType.value : null,
        title: data.title,
        description: data.description,
        typeGainLossId: data.typeGainLossId ? data.typeGainLossId.value : null,
        // methodologyId: data.methodologyId.value,
        // riskCauseId: data.riskCauseId.value,
        // riskSubCauseId: watchRiskSubcause['value'],
        departmentStakeholderId: data.departmentStakeholderId.value,
        courtCategoryId: data.courtCategoryId.value,
        userResponsibleId: data.userResponsibleId.value,
        userResponsibleLogin: userResponsibleLogin,
        // processId: watchProcess['value'],
        // subprocessId: watchSubprocess['value'],
        estimatedGrossLost: parseFormattedNumber(data.estimatedGrossLost),
        comment: data.comment ? data.comment : '',
        // businessLineId: data.businessLineId ? data.businessLineId.value : null,
        userCreatedId: user.id,
        riskEstimationId: riskEstimation,
      },
      riskExpenses: lossData.length > 0 ? lossData.map((item) => (
        {
          lossReason: {
            id:item?.lossReason.value,
            name: item?.lossReason.label
          },
          netLoss: parseFormattedNumber(item?.netLoss),
          lossDate: item?.lossDate,
          description: item?.description
        }
      )) : [],
    };

    try {
      const response = await addLitigation(payload, files);
      if (response.status === 201) {
        await Toast.fire({
          title: t('litigation.messages.addSuccess'),
          icon: 'success',
        });
        setIsAdding(false);
      }
      await history.push(`/court-risk/${response.data.id}`);
    } catch (err) {
      if (err.response.data.code === 'risk-exists') {
        Toast.fire({
          title:
            lang === 'eng'
              ? err.response.data.description
              : t('litigation.messages.addErrorExists'),
          icon: 'error',
        });
        document.getElementById('title').focus();
        document.getElementById('title').select();
      } else {
        Toast.fire({
          title: t('litigation.messages.addError'),
          icon: 'error',
        });
        setIsAdding(false);
      }
    }
  };
  useEffect(() => {
    const fetchSubjectStatuses = async () => {
      try {
        const { data } = await getSubjectStatus();
        setSubjectStatusOptions(
          data.map((item) => ({
            value: item.id,
            label: item.name,
          }))
        );
      } catch (e) {}
    };

    fetchSubjectStatuses();
  }, []);

  // useEffect(() => {
  //   if (watchProcess?.value) {
  //     setDisableSubPorcess(false);
  //
  //     const processChanged =
  //       prevProcessRef.current !== undefined &&
  //       prevProcessRef.current !== watchProcess.value;
  //
  //     if (processChanged) {
  //       setValue('subprocessId', '', {
  //         shouldValidate: false,
  //         shouldDirty: false,
  //       });
  //       setSubProcesses([]);
  //       setSubprocessPage(0);
  //       setHasMoreSubprocesses(true);
  //     }
  //     prevProcessRef.current = watchProcess.value;
  //     fetchSubprocesses(0, true);
  //   } else {
  //     setDisableSubPorcess(true);
  //     setSubProcesses([]);
  //     setSubprocessPage(0);
  //     setHasMoreSubprocesses(true);
  //     prevProcessRef.current = undefined;
  //
  //     setValue('subprocessId', '', {
  //       shouldValidate: false,
  //       shouldDirty: false,
  //     });
  //   }
  // }, [watchProcess]);
  useEffect(() => {
    if (watchCategory?.value) {
      setDisableSubCategory(false);

      const categoryChanged =
        prevRiskCategory.current !== undefined &&
        prevRiskCategory.current !== watchCategory?.value;
      if (categoryChanged) {
        setValue('subCategory', '', {
          shouldValidate: false,
          shouldDirty: false,
        });
        setSubCategories([]);
        setSubCategoriesPage(0);
        setHasMoreSubCategories(true);
      }
      prevRiskCategory.current = watchCategory?.value;
      setSubcategoriesSearch('')
      fetchSubCategories(0, true, '');
    } else {
      setDisableSubCategory(true);
      setSubCategories([]);
      setSubCategoriesPage(0);
      setHasMoreSubCategories(true);
      prevRiskCategory.current = undefined;
      setValue('subCategory', '', {
        shouldValidate: false,
        shouldDirty: false,
      });
    }
  }, [watchCategory]);

  useEffect(() => {
    if (watchDepartmentSourceId) {
      const depratmentObject = async () => {
        try {
          const {data} = await getDepartment(watchDepartmentSourceId.value);
          setUserResponsibleLogin(data[0]?.userResponsibleLogin)
          setValue('userResponsibleId', {
            value: data[0].userResponsibleId,
            label:
              data[0].userResponsibleFirstName +
              ' ' +
              data[0].userResponsibleLastName,
          });
        } catch {}
      };
      depratmentObject();
    }
  }, [watchDepartmentSourceId]);
  //
  // const handleSubprocessLoadMore = () => {
  //   if (hasMoreSubprocesses && !loadingSubprocesses) {
  //     fetchSubprocesses(subprocessPage + 1, false);
  //   }
  // };
  // const handleRiskSubCauseLoadMore = () => {
  //   if (hasMoreSubCauses && !loadingSubCauses) {
  //     fetchSubcauses(subCausePage + 1, false);
  //   }
  // };
  const handleRiskSubCategoriesLoadMore = () => {
    if (hasMoreSubCategories && !loadingSubCategories) {
      fetchSubCategories(subCategoriesPage + 1, false, subCategoriesSearch);
    }
  };
  const handleSubcategoriesSearch = (value) => {
    setSubcategoriesSearch(value);
    setSubCategoriesPage(0);
    setHasMoreSubCategories(true);
    if (!value) {
      fetchSubCategories(0, true, '');
      return;
    }
    fetchSubCategories(0, true, value);
  };
  const deleteConto = (id) => {
    setLossModalOpen(false);

    const itemToDelete = lossData.find(
      (item) => item.id === id || item.tempId === id
    );

    if (itemToDelete && typeof itemToDelete?.id === 'number') {
      setDeletedLossIds((prev) => [...prev, itemToDelete.id]);
    }

    setLossData((prevLossData) =>
      prevLossData.filter(
        (item) => item.id !== id && item.tempId !== id
      )
    );
  };

  useEffect(() => {
    const index = lossData.findIndex((loss) => loss.id === currentID);
    if (index !== -1) {
      const selectedLoss = lossData[index];
      setValue(`lossData.${index}.account`, selectedLoss?.lossReason);
    }
  },[lossData]);
  const sum = lossData.reduce((acc, item) => {
    const value = parseFormattedNumber(item?.netLoss) || 0;
    return acc + value;
  }, 0);

  const netLossNumberValue = sum -
    parseFormattedNumber(watch('lossChargedInsurance')) -
    parseFormattedNumber(watch('lossChargedOther'))

  const handleChange = (event) => {
    event.target.value = formatNumberInput(event.target.value);
  };
  return (
    <>
      <PreventTransitionPrompt when={isAdding} />
      <PageHeader />
      <div className="main-form mt-4">
        <FormProvider {...methods}>
          <form onSubmit={handleSubmit(submitForm)}>
            <Row className="field-group-title">
              <Col className="col-4 col-xl-2">{t('litigation.mainData')}</Col>
            </Row>
            <Row className="mb-2">
              <Col className="col-6 col-xl-3">
                <label className="label-litigation">
                  {t('litigation.title')}
                </label>
                <InputText
                  type="text"
                  name="title"
                  id="title"
                  className="form-control input-field"
                  placeholder={t('litigation.placeholder.title')}
                />
              </Col>
              <Col className="col-6 col-xl-3">
                <label className="label-litigation">
                  {t('litigation.description')}
                </label>
                <TextArea
                  name="description"
                  className={`form-control text-area `}
                  placeholder={t('litigation.placeholder.description')}
                />
              </Col>
            </Row>
            <Row className="mb-2">
              <Col className="col-6 col-xl-3">
                <label className="label-litigation">
                  {t('litigation.potentionalRisk')}
                </label>
                <span className="optional register">
                  {t('common.optional')}
                </span>
                <SelectInfinite
                  api="/risks?riskTypeId.equals=1"
                  name="riskType"
                  placeholder={t('incurred-risk.placeholder.potentionalRisk')}
                  labelKey={'title'}
                  className="select"
                  isClearable
                  queryKeys={'title.contains'}
                />
              </Col>
            </Row>
            <Row className="mt-5 field-group-title">
              <Col className="col-4 col-xl-2">
                {t('litigation.litigationInfo')}
              </Col>
            </Row>
            <Row>
              <Col className="col-6 col-xl-3">
                <label className="label-litigation">
                  {t('litigation.typeCourtDispute')}
                </label>
                <InputText
                  type="text"
                  name="typeCourtDispute"
                  className="form-control input-field"
                  placeholder={t('litigation.placeholder.typeCourtDispute')}
                />
              </Col>
              <Col className="col-6 col-xl-3">
                <label className="label-litigation" htmlFor="bankLegitimation">
                  {t('litigation.bankLegitimation')}
                </label>
                <SelectList
                  name="bankLegitimation"
                  placeholder={t('litigation.placeholder.bankLegitimation')}
                  options={bankLegitimation}
                  isClearable
                />
              </Col>
              <Col className="col-6 col-xl-3">
                <label className="label-litigation">
                  {t('litigation.proxyInfo')}
                </label>
                <InputText
                  type="text"
                  name="proxyInfo"
                  className="form-control input-field"
                  placeholder={t('litigation.placeholder.proxyInfo')}
                />
              </Col>
              <Col className="col-6 col-xl-3 d-flex flex-column">
                <label className="label-litigation">
                  {t('litigation.litigationDate')}
                </label>
                <InputDate
                  name="litigationDate"
                  placeholder={t('litigation.placeholder.litigationDate')}
                  style={{height: '45px!important', width: '100%'}}
                  isClearable={true}
                  // maxDate={new Date()}
                />
              </Col>
            </Row>
            <Row>
              <Col className="col-6 col-xl-3">
                <label className="label-litigation">
                  {t('litigation.disputeSubject')}
                </label>
                <InputText
                  type="text"
                  name="disputeSubject"
                  className="form-control input-field"
                  placeholder={t('litigation.placeholder.disputeSubject')}
                />
              </Col>
              <Col className="col-6 col-xl-3">
                <label className="label-litigation">
                  {t('litigation.jurisdiction')}
                </label>
                <InputText
                  type="text"
                  name="jurisdiction"
                  className="form-control input-field line-height"
                  placeholder={t('litigation.placeholder.jurisdiction')}
                />
              </Col>
              <Col className="col-6 col-xl-3">
                <label className="label-litigation">
                  {t('litigation.litigationValue')}
                </label>
                <InputText
                  type="text"
                  name="litigationValue"
                  className="form-control input-field"
                  placeholder={t('litigation.placeholder.litigationValue')}
                  onChange={(e) => onDecimalNumberInputChange(e,setValue,"litigationValue")}
                  onPaste={(e) => handlePasteAndValidate(e, setValue, trigger, 'litigationValue')}
                />
              </Col>
              <Col className="col-6 col-xl-3">
                <label className="label-litigation">
                  {t('litigation.provisionAmount')}
                </label>
                <span className="optional register">
                  {t('common.optional')}
                </span>
                <InputText
                  type="text"
                  name="provisionAmount"
                  className="form-control input-field line-height"
                  placeholder={t('litigation.placeholder.provisionAmount')}
                  onChange={(e) => onDecimalNumberInputChange(e,setValue,"provisionAmount")}
                  onPaste={(e) => handlePasteAndValidate(e, setValue, trigger, 'provisionAmount')}
                />
              </Col>
            </Row>
            <Row>
              <Col className="col-6 col-xl-3">
                <label className="label-litigation">
                  {t('litigation.reimbursementProvision')}
                </label>
                <InputText
                  type="text"
                  name="reimbursementProvision"
                  className="form-control input-field line-height"
                  placeholder={t(
                    'litigation.placeholder.reimbursementProvision'
                  )}
                  // step=".01"
                  // min="0"
                  onChange={(e) => onDecimalNumberInputChange(e,setValue,"reimbursementProvision")}
                  onPaste={(e) => handlePasteAndValidate(e, setValue, trigger, 'reimbursementProvision')}
                />
              </Col>
              <Col className="col-6 col-xl-3">
                <label className="label-litigation">
                  {t('litigation.litigationLoss')}
                </label>
                <span className="optional register">
                  {t('common.optional')}
                </span>
                <InputText
                  type="text"
                  name="litigationLoss"
                  className="form-control input-field line-height"
                  placeholder={t('litigation.placeholder.litigationLoss')}
                  onChange={(e) => onDecimalNumberInputChange(e,setValue,"litigationLoss")}
                  onPaste={(e) => handlePasteAndValidate(e, setValue, trigger, 'litigationLoss')}
                />
              </Col>
              <Col className="col-6 col-xl-3">
                <label className="label-litigation">
                  {t('litigation.subjectStatus')}
                </label>
                <SelectList
                  name="subjectStatus"
                  placeholder={t('litigation.placeholder.subjectStatus')}
                  className="select"
                  options={subjectStatusOptions}
                />
              </Col>
              <Col className="col-6 col-xl-3">
                <label className="label-litigation">
                  {t('litigation.courtDisputeOutcomeAssessment')}
                </label>
                <TextArea
                  name="courtDisputeOutcomeAssessment"
                  className={`form-control text-area `}
                  placeholder={t('litigation.placeholder.courtDisputeOutcomeAssessment')}
                />
              </Col>
            </Row>
            <Row className="mt-5 field-group-title">
              <Col className="col-6 col-xl-3">
                {t('litigation.additionalInformation')}
              </Col>
            </Row>
            <Row className="mt-2">
              <Col className="col-3 col-xl-3">
                <label className="label-litigation">
                  {t('litigation.category')}
                </label>
                <SelectInfinite
                  api="court-category-risks"
                  name="courtCategoryId"
                  placeholder={t('litigation.placeholder.category')}
                  labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                  className="select"
                />
                <label className="label-litigation">
                  {t('litigation.subCategory')}
                </label>
                <SelectList
                  name="subCategory"
                  isDisabled={disableSubCategory}
                  placeholder={t('litigation.placeholder.subCategory')}
                  options={subCategories}
                  isClearable
                  onLoadMore={handleRiskSubCategoriesLoadMore}
                  hasMore={hasMoreSubCategories}
                  isLoading={loadingSubCategories}
                  onSearch={handleSubcategoriesSearch}
                />
              {/*  <label className="label-litigation">*/}
              {/*    {t('litigation.riskCauses')}*/}
              {/*  </label>*/}
              {/*  <SelectInfinite*/}
              {/*    api="risk-causes"*/}
              {/*    name="riskCauseId"*/}
              {/*    placeholder={t('litigation.placeholder.riskCauses')}*/}
              {/*    labelKey={lang === 'mne' ? 'name' : 'nameEn'}*/}
              {/*    className="select"*/}
              {/*    ref={prevRiskCause}*/}
              {/*  />*/}
              {/*  <label className="label-litigation">*/}
              {/*    {t('litigation.riskSubCause')}*/}
              {/*  </label>*/}
              {/*  <SelectList*/}
              {/*    name="riskSubCause"*/}
              {/*    isDisabled={disableSubCauses}*/}
              {/*    className="select"*/}
              {/*    placeholder={t('litigation.placeholder.riskSubCause')}*/}
              {/*    options={subCauses}*/}
              {/*    labelKey={lang === 'mne' ? 'name' : 'nameEn'}*/}
              {/*    isClearable*/}
              {/*    onLoadMore={handleRiskSubCauseLoadMore}*/}
              {/*    hasMore={hasMoreSubCauses}*/}
              {/*    isLoading={loadingSubCauses}*/}
              {/*  />*/}
              </Col>
              <Col className="col-3 col-xl-3">
                {/*<label className="label-litigation">*/}
                {/*  {t('litigation.businessLines')}*/}
                {/*</label>*/}
                {/*<span className="optional register">*/}
                {/*  {t('common.optional')}*/}
                {/*</span>*/}
                {/*<SelectInfinite*/}
                {/*  api="business-lines"*/}
                {/*  name="businessLineId"*/}
                {/*  placeholder={t('litigation.placeholder.businessLines')}*/}
                {/*  labelKey={lang === 'mne' ? 'name' : 'nameEn'}*/}
                {/*  className="select"*/}
                {/*/>*/}
                <label className="label-litigation">
                  {t('litigation.estimatedGrossLoss')}
                </label>
                <InputText
                  type="text"
                  name="estimatedGrossLost"
                  className="form-control input-field"
                  placeholder={t('litigation.placeholder.estimatedGrossLoss')}
                  onChange={(e) => onDecimalNumberInputChange(e,setValue,"estimatedGrossLost")}
                  onPaste={(e) => handlePasteAndValidate(e, setValue, trigger, 'estimatedGrossLost')}
                />
                <label className="label-litigation">
                  {t('litigation.typeGainLoss')}
                </label>
                <span className="optional register">
                  {t('common.optional')}
                </span>
                <SelectInfinite
                  api="type-gain-losses"
                  name="typeGainLossId"
                  placeholder={t('litigation.placeholder.typeGainLoss')}
                  labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                  className="select"
                />
              </Col>
              <Col className="col-3 col-xl-3">
                <label className="label-litigation">
                  {t('litigation.department')}
                </label>
                <SelectList
                  name="departmentStakeholderId"
                  options={departmentOptions}
                  placeholder={t('litigation.placeholder.department')}
                />
                {userDepartment?.length === 1 ? (
                  <>
                    <label className="label-potential-risk">
                      {t('litigation.responsibleUser')}
                    </label>
                    <SelectInfinite
                      api="users"
                      name="userResponsibleId"
                      labelKey="firstName"
                      placeholder={t('litigation.placeholder.responsibleUser')}
                      className="select"
                      isDisabled={true}
                      defaultValue={{
                        value:
                          userDepartment[0]?.id !== undefined
                            ? userDepartment[0]?.userResponsibleId
                            : '',
                        label:
                          userDepartment[0]?.id !== undefined
                            ? userDepartment[0]?.userResponsibleFirstName +
                            ' ' +
                            userDepartment[0]?.userResponsibleLastName
                            : '',
                      }}
                    />
                  </>
                ) : (
                  <>
                    <label className="label-potential-risk">
                      {t('litigation.responsibleUser')}
                    </label>
                    <SelectInfinite
                      api="users"
                      name="userResponsibleId"
                      labelKey="firstName"
                      placeholder={t('litigation.placeholder.responsibleUser')}
                      className="select"
                      isDisabled={true}
                    />
                  </>
                )}
              </Col>
              <Col className="col-3 col-xl-3">
                {/*<label className="label-litigation">*/}
                {/*  {t('litigation.process')}*/}
                {/*</label>*/}
                {/*<SelectInfinite*/}
                {/*  api="processes"*/}
                {/*  name="process"*/}
                {/*  labelKey={lang === 'mne' ? 'name' : 'nameEn'}*/}
                {/*  placeholder={t('litigation.placeholder.process')}*/}
                {/*  className="select"*/}
                {/*  ref={prevProcessRef}*/}
                {/*/>*/}
                {/*<label className="label-litigation">*/}
                {/*  {t('litigation.subprocess')}*/}
                {/*</label>*/}
                {/*<SelectList*/}
                {/*  name="subprocessId"*/}
                {/*  options={subProcesses}*/}
                {/*  isDisabled={disableSubprocess}*/}
                {/*  placeholder={t('litigation.placeholder.subprocess')}*/}
                {/*  isClearable*/}
                {/*  onLoadMore={handleSubprocessLoadMore}*/}
                {/*  hasMore={hasMoreSubprocesses}*/}
                {/*  isLoading={loadingSubprocesses}*/}
                {/*/>*/}
                <label className="label-litigation" htmlFor={'attachFile'}>
                  {t('litigation.attachFiles')}
                </label>
                <FileUploadSection />
                <label className="label-litigation">
                  {t('litigation.additionalComment')}
                </label>
                <span className="optional register">
                  {t('common.optional')}
                </span>
                <TextArea
                  name="comment"
                  className={`form-control text-area`}
                  // placeholder={t('litigation.placeholder.additionalComment')} disabled={disabled}
                />
              </Col>
            </Row>

            <Row className="mb-2 occured-loss-footer">
              <Col className="col-3 col-xl-3">
                <label className="label-incurred">
                  {t('codebook.addExpense')}
                </label>
                <span className="optional register">
                  {t('common.optional')}
                </span>
                <p className={'file-input'} style={{marginBottom: '-8px'}} onClick={() => {
                  setIsEdit(false)
                  setLossModalOpen(true)
                }}></p>
                <LossModal
                  open={lossModalOpen}
                  setLossData={setLossData}
                  lossData={lossData}
                  id={currentID}
                  isEdit={isEdit}
                  isOpen={(e) => setLossModalOpen(e)}
                />
              </Col>
            </Row>
            <Row>
              {lossData.map((item,index) => (
                <>
                  <Col className="col-2">
                    <label className="label-incurred">
                      {t('codebook.codebook')}
                    </label>
                    <SelectInfinite
                      api="/loss-reasons"
                      name={`lossData.${index}.account`}
                      placeholder={t('incurred-risk.placeholder.category')}
                      labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                      className="select"
                      isDisabled={true}
                      defaultValue={item?.lossReason}
                    />
                  </Col>
                  <Col className="col-2" style={{marginRight: '5px'}}>
                    <label className="label-incurred">
                      {window.location.pathname.includes('court-risk') ? t('codebook.paymentDate') : t('codebook.lossDate')}
                    </label>
                    <InputDate
                      name="lossDate"
                      selected={new Date(item?.lossDate)}
                      placeholder={t('codebook.lossDatePlaceholder')}
                      style={{height: '65px!important'}}
                      forceSelected={true}
                      disabled={true}
                      isClearable={false}
                    />
                  </Col>
                  <Col className="col-2" style={{marginRight: '5px'}}>
                    <label className="label-incurred mt-2">
                      {t('codebook.descriptionLoss')}
                    </label>
                    <TextArea
                      name="descriptionLoss"
                      disabled={true}
                      key={`description-${item.id ?? item.tempId}-${item.description}`}
                      value={item?.description}
                      placeholder={t('codebook.descriptionLossPlaceholder')}
                    />
                  </Col>
                  <Col className="col-2" style={{marginRight: '5px'}}>
                    <label className="label-incurred">
                      {window.location.pathname.includes('court-risk') ? t('codebook.paymentAmount') : t('codebook.loss')}
                    </label>
                    <InputText
                      type="text"
                      name="netLoss"
                      className="form-control input-field"
                      placeholder={t('incurred-risk.placeholder.title')}
                      disabled={true}
                      value={item?.netLoss}
                    />
                  </Col>
                  <div style={{width: '10%',display:'flex',marginLeft: '20px', marginBottom: '55px', alignItems:'center'}}>
                    <img style={{marginTop: '30px',marginRight: '5px',cursor: 'pointer'}} onClick={() => {
                      setLossModalOpen(true)
                      setCurrentID(item.id ?? item.tempId);
                      setIsEdit(true);
                    }} src={editImage} alt={'edit'}/>
                    <img style={{marginTop: '30px',cursor: 'pointer'}} onClick={() => deleteConto(item?.id ?? item?.tempId)} src={deleteImage} alt={'delete'}/>
                  </div>
                </>
              ))}
            </Row>
            <Row>
              {watchNetLoss &&
                <>
                <Col className="col-2" style={{marginRight: '5px'}}>
                  <label className="label-incurred">
                    {t('litigation.grossLoss')}
                  </label>
                  <InputText
                    type="text"
                    name="grossLoss"
                    className="form-control input-field"
                    placeholder={t('litigation.placeholder.placeholder.grossLoss')}
                    disabled={true}
                    value={formatNumber(sum)}
                  />
                </Col>
                <Col className="col-2" style={{marginRight: '5px'}}>
                  <label className="label-incurred">
                    {t('litigation.lossChargedInsurance')}
                  </label>
                  <InputText
                    type="text"
                    name="lossChargedInsurance"
                    onChange={handleChange}
                    className="form-control input-field"
                    placeholder={t('litigation.placeholder.lossChargedInsurance')}
                  />
                </Col>
                <Col className="col-2" style={{marginRight: '5px'}}>
                  <label className="label-incurred">
                    {t('litigation.lossChargedOther')}
                  </label>
                  <InputText
                    type="text"
                    name="lossChargedOther"
                    className="form-control input-field"
                    onChange={handleChange}
                    placeholder={t('litigation.placeholder.lossChargedOther')}
                  />
                </Col>
                <Col className="col-2" style={{marginRight: '5px'}}>
                  <label className="label-incurred">
                    {t('litigation.netLossNumber')}
                  </label>
                  <InputText
                    type="text"
                    name="netLossNumber"
                    className="form-control input-field"
                    placeholder={t('litigation.placeholder.netLossNumber')}
                    disabled={true}
                    value={formatNumber(netLossNumberValue)}
                  />
                </Col>
                </>}
            </Row>
            <Row className="mt-5 form-footer">
              <button
                className="secondary-btn"
                type="reset"
                onClick={handleCancel}
              >
                {t('buttons.cancel')}
              </button>
              <button className="primary-btn">{t('buttons.save')}</button>
            </Row>
          </form>
        </FormProvider>
      </div>
    </>
  );
};
export default AddLitigation;
